/**
 * MerakiSubNav — single source of truth for the Meraki page list.
 *
 * Render this near the top of every `/meraki/*` page so the user can hop
 * between siblings without using the global sidebar.
 *
 * As pages get migrated, flip a `dim: true` entry to a `to:` entry — the
 * layout stays stable so the user's spatial memory survives the migration.
 */
import { SubNav } from "@/components/app/sub-nav";

export function MerakiSubNav() {
  return (
    <SubNav
      items={[
        { label: "Provisioning", to: "/meraki/provisioning" },
        { label: "Network Backup", to: "/meraki/network-backup" },
        { label: "Post Sign-off", to: "/meraki/post-signoff" },
        { label: "API suite", to: "/meraki/api-suite" },
        { label: "Switch ports", to: "/meraki/switch-ports" },
        { label: "Update devices", to: "/meraki/update-devices" },
        { label: "Onboarding", to: "/meraki/onboarding" },
      ]}
    />
  );
}
